import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../utils/constants';

function CodeOfConductPage() {
  return (
    <div className="page">
      <div className="container">
        <div className="content-page">
          <h1>Code of Conduct</h1>

          <section className="content-section">
            <p>
              QDN exists to be a safer, queer-affirming space for people working with data and tech. 
              The Code of Conduct explains what behavior is expected here and how moderation will respond when harm occurs.
            </p>
          </section>

          <section className="content-section">
            <h2>Core Values</h2>
            <ul>
              <li>Respect and safety for LGBTQ+ people across genders, sexualities, races, and abilities.</li>
              <li>Trans-affirming and intersex-affirming language and practice.</li>
              <li>Anti-racism, anti-ableism, anti-fatphobia, and opposition to harassment and hate.</li>
              <li>Consent, privacy, and minimizing risk when discussing or sharing data about real people.</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>Expected Behavior</h2>
            <p>Members are expected to:</p>
            <ul>
              <li>Use people's stated names and pronouns; avoid assumptions about gender, body, or relationship structure.</li>
              <li>Discuss identities, trauma, and harm with care; step back if someone says a topic or interaction is not okay for them.</li>
              <li>Anonymize and aggregate examples when discussing sensitive data; avoid sharing any data that could identify individuals without explicit consent.</li>
              <li>Assume good faith while still taking responsibility for impact over intent.</li>
              <li>Welcome feedback about language and be willing to correct mistakes.</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>Unacceptable Behavior</h2>
            <p>The following are not allowed:</p>
            <ul>
              <li>Harassment or hate speech, including slurs, targeted misgendering, or sustained "debates" over people's right to exist.</li>
              <li>Racism, antisemitism, Islamophobia, xenophobia, ableism, fatphobia, or other forms of bigotry.</li>
              <li>Doxxing, outing, or sharing identifying details (names, photos, usernames, datasets, locations) without consent.</li>
              <li>
                Promoting or requesting data uses that would likely lead to surveillance, criminalization, or forced outing of queer and trans people 
                (for example, law-enforcement targeting, "risk scoring," or non-consensual facial recognition of queer communities).
              </li>
              <li>Explicit sexual content directed at individuals, or content that sexualizes minors.</li>
            </ul>
            <p>
              Concrete examples of what will be removed include: posting someone's old usernames without consent; sharing a small-n dataset of 
              trans people's locations; "debunking" someone's gender; or organizing harassment on or off the platform.
            </p>
          </section>

          <section className="content-section">
            <h2>Reporting and Moderation</h2>
            <p>
              If something makes you feel unsafe or uncomfortable here, you can report it through the built-in report tool on posts or profiles, 
              or by emailing the moderators at <a href="mailto:support@queerdatanetwork.com">support@queerdatanetwork.com</a>. Reports can be anonymous, 
              though including a way to follow up may help moderators respond.
            </p>

            <h3>When a report is submitted, moderators may:</h3>
            <ul>
              <li>Hide or remove content, posts, or comments.</li>
              <li>Reach out to the people involved to clarify context and set boundaries.</li>
              <li>Issue warnings, temporary suspensions, or permanent bans for serious or repeated violations.</li>
            </ul>

            <p>
              Moderators will prioritize the safety of people targeted by harm, especially those at higher risk because of race, gender, 
              disability, immigration status, criminalization, or other factors.
            </p>
          </section>

          <section className="content-section cta-section">
            <Link to={ROUTES.GETTING_STARTED} className="btn btn-primary">
              Get Started
            </Link>
            <Link to={ROUTES.CONTACT} className="btn btn-outline">
              Contact Us
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CodeOfConductPage;
